import React from 'react';
const rows = [{
  now: 'Vendi sedute singole, una alla volta',
  withSystem: 'Proponi un percorso di 10 sedute in 3 fasi, definito prima di iniziare'
}, {
  now: 'Ogni seduta la prepari da zero',
  withSystem: 'Apri la scheda della fase in cui sei'
}, {
  now: 'Il cliente non sa se sta progredendo',
  withSystem: 'Il cliente ha una mappa e la vede aggiornarsi a ogni seduta'
}, {
  now: 'La seduta numero quattro è quella che temi',
  withSystem: 'È la seduta per cui hai un protocollo'
}, {
  now: 'Il percorso finisce nel silenzio',
  withSystem: 'Finisce con un dossier, un bilancio e una richiesta di feedback'
}, {
  now: 'Bravo ascoltatore',
  withSystem: 'Guida con un metodo'
}];
export function Transformation() {
  return <section aria-labelledby="transformation-heading" className="w-full bg-white" data-id="element-236" data-mp="1fbuwtw2389oy">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-237" data-mp="1k9d83t3kv104">
        <h2 id="transformation-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center max-w-2xl mx-auto leading-tight" data-id="element-238" data-mp="1k7k2mh4pamtp">
          Da “improvviso e funziona” a “conduco e si vede”
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-cream-dark shadow-card" data-id="element-239" data-mp="1364yzyrk5ovq">
          <table className="w-full text-left" data-id="element-240" data-mp="y7afeulrnwak">
            <thead data-id="element-241" data-mp="y8lmb3aidk5w">
              <tr data-id="element-242" data-mp="1uw9p8e20164v">
                <th className="w-1/2 bg-cream-dark px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-ink-soft" data-id="element-243" data-mp="1uvghb9rb0al5">
                  Adesso
                </th>
                <th className="w-1/2 bg-vital-soft px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-vital" data-id="element-244" data-mp="1m3ob5b9bbnmd">
                  Con il Sistema Completo
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-dark" data-id="element-245" data-mp="2elag47sfrpyv">
              {rows.map(row => <tr key={row.now} className="bg-white align-top" data-id="element-246" data-mp="29sqzt32d6gqd">
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] text-ink-muted" data-id="element-247" data-mp="2sqasq3mku8oa">
                    {row.now}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] font-semibold text-ink" data-id="element-248" data-mp="2xom2yfgsal71">
                    {row.withSystem}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}